import { render, staticRenderFns } from "./AuthorizePaymentPopup.vue?vue&type=template&id=151dc55f"
import script from "./AuthorizePaymentPopup.vue?vue&type=script&lang=js"
export * from "./AuthorizePaymentPopup.vue?vue&type=script&lang=js"
import style0 from "./AuthorizePaymentPopup.vue?vue&type=style&index=0&id=151dc55f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports